module.exports = __webpack_public_path__ + "static/media/Cart-Icon-Black.f9e85da7.svg";